import { type HTMLAttributes, useEffect, useRef } from "react";
import { ColumnGroupingCell } from "src/components/DataGrid/product/ColumnGroupingCell.tsx";
import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";

export function ComplexProductVariantGroupingCell(
  props: HTMLAttributes<HTMLButtonElement> & {
    isLastChild: boolean;
  },
) {
  const { isLastChild, ...rest } = props;

  return (
    <ColumnGroupingCell {...rest}>
      <TreePathCanvas
        {...{
          isLastChild,
        }}
      />
    </ColumnGroupingCell>
  );
}

export type DrawLeafPathProps = {
  isLastChild?: boolean;
};

export const TreePathCanvas = (props: DrawLeafPathProps) => {
  const { isLastChild } = props;
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const theme = useNonConflictingTheme();

  useEffect(() => {
    if (!canvasRef.current) return;

    const { width, height } = canvasRef.current;
    const ctx = canvasRef.current.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, width, height);
    ctx.strokeStyle = theme.colorsV2.grey[200];
    ctx.lineWidth = 2;

    ctx.beginPath();

    ctx.moveTo(width / 2, 0);
    ctx.lineTo(width / 2, isLastChild ? height / 2 : height);

    ctx.moveTo(width / 2, height / 2);
    ctx.lineTo(width, height / 2);

    ctx.stroke();
  }, [isLastChild, theme]);

  return (
    <canvas
      ref={canvasRef}
      width={60}
      height={theme.productDataGrid.rowHeight}
      css={{ position: "absolute", zIndex: 1 }}
    />
  );
};
